import globalCommand from './command';

function serializePacket(packet) {
    return JSON.stringify(packet);
}

function deserializePacket(packetString) {
    return JSON.parse(packetString);
}

//编码
export const packetEncoder = function(packet,command){
    const xNumber = 0x12345678;  // 替换为实际的魔数
    const xVersion = 0x01;
    const algorithm = 0x01;
    if(!command){
        return;
    }
    const commamd = command;

    let bodyBytes;
    if(command===globalCommand.image_data){ //图片数据
        bodyBytes = packet.chunkData;
    }else{
        bodyBytes = new TextEncoder().encode(serializePacket(packet));
    }
    //const bodyBytes = new TextEncoder().encode(serializePacket(packet));


    //const bodyLength = bodyBytes.length;
    const bodyLength = bodyBytes.byteLength;
    let buffer = new ArrayBuffer(4 + 1 + 1 + 4 + 4 + bodyLength);
    const dataView = new DataView(buffer);

    let offset = 0;

    // 写入魔数
    dataView.setUint32(offset, xNumber, false);
    offset += 4;

    // 写入版本号
    dataView.setUint8(offset, xVersion);
    offset += 1;
    // 写入序列化算法
    dataView.setUint8(offset, algorithm);
    offset += 1;

    // 写入指令
    dataView.setUint32(offset, commamd, false);
    offset += 4;

    // 写入body长度
    dataView.setUint32(offset, bodyLength, false);
    offset += 4;

    // 写入body
    // for (let i = 0; i < bodyBytes.length; i++) {
    //     dataView.setUint8(offset + i, bodyBytes[i]);
    // }
    new Uint8Array(buffer).set(new Uint8Array(bodyBytes),offset);
    return buffer;
}

//解码
export const packetDecoder = function(decodePacket) {
    const dataView = new DataView(decodePacket);

    let offset = 0;

    // 读取魔数
    const xNumber = dataView.getUint32(offset, false);
    offset += 4;

    // 读取版本号
    const xVersion = dataView.getUint8(offset);
    offset += 1;

    // 读取序列化算法
    const algorithm = dataView.getUint8(offset);
    offset += 1;

    // 读取指令
    const command = dataView.getUint32(offset, false);
    offset += 4;

    // 读取body长度
    const bodyLength = dataView.getUint32(offset, false);
    offset += 4;

    // 读取body
    const bodyBytes = new Uint8Array(decodePacket, offset, bodyLength);
    const bodyString = new TextDecoder().decode(bodyBytes);
    const packet = deserializePacket(bodyString);

    //console.log("bodyString=="+bodyString);

    let respObject = {
        command:command,
        code:packet.code,
        message:packet.message,
        data:packet.data
    }

    return respObject;
}

